export enum Category {
  PART = 'PART',

  LABOR = 'LABOR',

  DIAGNOSTIC = 'DIAGNOSTIC',

  OTHER = 'OTHER',
}
